import { XMLParser, XMLValidator } from 'fast-xml-parser';
import { sendSumoLog } from './sumoLogger';
import { updateContactList, updateError } from '../../stores/notifications';

/**
 * The contacts list / grid to display for notifications.
 *
 * @param token - authentication token from active auth.
 * @param dispatch - redux dispatch to dispatch state changes.
 * @returns {Promise<[Contacts]>} - Contacts for notifications.
 */
export const fetchContactList = async (token, dispatch) => {
  const requestURL = encodeURI(
    `https://${process.env.REACT_APP_API_SUBDOMAIN}.pge-811.com/ticket-notification/users`
  );
  const headers = new Headers({
    Authorization: `Bearer ${token}`,
  });

  try {
    const data = await fetch(requestURL, {
      method: 'GET',
      headers,
    });

    //Todo: We need to do an error check within the body when the text is more than 200
    if (!data.ok) {
      throw {
        message: `Failed to GET contacts list with error code: ${data.status}`,
        errorCode: data.status,
      };
    }

    const xml = await data.text();
    let contactList = null;

    try {
      if (XMLValidator.validate(xml)) {
        const parser = new XMLParser({});
        let res = parser.parse(xml);

        if (res && res.ListBucketResult) {
          // ListBucketResults will always be present on a successful call.
          // However, Contents will be empty on no results.
          if (res.ListBucketResult.Contents) {
            contactList = res.ListBucketResult.Contents.reduce(function(result, content) {
              const contactKey = content.Key;
              const userId = contactKey.substr(6).split('.')[0];
              if (userId) { // do not push an empty userId
                result.push({ userId });
              }

              return result;
            }, []);
          } else {
            contactList = [];
          }
        }
      }
    } catch (error) {
      const isInternalError = error instanceof Error;
      const errorType = 'XMLParser.parse';
      const errorCode = isInternalError ? 500 : error.errorCode;
      sendSumoLog(errorType, error.message, errorCode, dispatch);
      throw error;
    }

    updateContactList(contactList, dispatch);
  } catch (error) {
    const isInternalError = error instanceof Error;
    const errorType = 'fetchContactList';
    const errorCode = isInternalError ? 500 : error.errorCode;
    sendSumoLog(errorType, error.message, errorCode, dispatch);
    updateError(error, dispatch);
    return null;
  }
};
